export enum Resolution {
  FiveMinutes = 'FIVE_MINUTES',
  Hour = 'HOUR',
  SixHours = 'SIX_HOURS',
  Day = 'DAY',
  Week = 'WEEK'
}
